import { oneOf, bool, object, string, shape, func } from 'prop-types';
import React from 'react';
import classnames from 'classnames';
import Comment from 'components/Icons/Comment';
import ExternalLink from 'components/Icons/ExternalLink';
import Facebook from 'components/Icons/Facebook';
import Flipboard from 'components/Icons/Flipboard';
import Pinterest from 'components/Icons/Pinterest';
import Instagram from 'components/Icons/Instagram';
import Mail from 'components/Icons/Mail';
import Twitter from 'components/Icons/Twitter';
import Youtube from 'components/Icons/Youtube';
import Bookmark from 'components/Icons/Bookmark';
import LinkIcon from 'components/Icons/ChainLinks';
import { createSocialUrl } from './helper';
import styles from './styles';

export const ICONS = {
  comment: Comment,
  email: Mail,
  external: ExternalLink,
  facebook: Facebook,
  flipboard: Flipboard,
  instagram: Instagram,
  pinterest: Pinterest,
  saveStory: Bookmark,
  twitter: Twitter,
  tweet: Twitter,
  youtube: Youtube,
  link: LinkIcon,
  saveStoryText: null
};

const LABELS = {
  comment: 'Comment',
  email: 'Email',
  external: 'Link',
  facebook: 'Facebook',
  flipboard: 'Flipboard',
  instagram: 'Instagram',
  pinterest: 'Pinterest',
  twitter: 'Twitter',
  tweet: 'Twitter',
  youtube: 'YouTube'
};

function ActionIcon(props) {
  const {
    isBranded,
    label,
    linkAttrs,
    onClick,
    shareProps,
    toggled,
    type,
    url,
    variant
  } = props;
  const Icon = ICONS[type];
  const href = createSocialUrl(type, url || shareProps);

  const socialNetwork = type === 'tweet' ? 'twitter' : type;

  const className = classnames(
    'ActionIcon',
    `ActionIcon--${socialNetwork}`,
    {
      [`ActionIcon--${variant}`]: variant,
      'ActionIcon--branded': isBranded,
      'ActionIcon--toggled': toggled
    },
    props.inheritedClass
  );

  const opts = {
    ...{
      href,
      className,
      onClick,
      rel: 'noopener noreferrer',
      'data-social-network': socialNetwork,
      'aria-label': label || LABELS[type],
      'data-gtm-social-network': socialNetwork,
      'data-gtm-ignore-outbound-link': 'true'
    },
    ...linkAttrs
  };

  return (
    <a {...opts}>
      <span className="ActionIcon__content">
        {Icon && <Icon isOutlined={!props.toggled} />}
        {label && <span className="ActionIcon__label">{label}</span>}
      </span>
      <style jsx>{styles}</style>
    </a>
  );
}

ActionIcon.defaultProps = {
  inheritedClass: '',
  isBranded: false,
  label: undefined,
  onClick: undefined,
  shareProps: undefined,
  target: undefined,
  toggled: true,
  url: undefined,
  variant: undefined,
  linkAttrs: {}
};

ActionIcon.propTypes = {
  inheritedClass: string,
  isBranded: bool,
  label: string,
  onClick: func,
  shareProps: shape({
    body: string,
    subject: string,
    url: string,
    description: string,
    media: string,
    u: string
  }),
  target: string,
  toggled: bool,
  type: oneOf([
    'comment',
    'email',
    'external',
    'facebook',
    'flipboard',
    'instagram',
    'pinterest',
    'twitter',
    'tweet',
    'youtube',
    'saveStory',
    'saveStoryText',
    'link'
  ]).isRequired,
  url: string,
  variant: string,
  linkAttrs: object // eslint-disable-line
};

export default ActionIcon;
